import * as categoryVideoActions from '../../action_creators/category/category_video_action_creators';
import CategoryVideoModel from '../../../models/category/category_video_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(categoryVideoActions.categoryVideoLoading());
    return CategoryVideoModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        dispatch(categoryVideoActions.categoryVideoLoaded(resp.data, store));
      })
      .catch(function handleUserError(err) {
        dispatch(categoryVideoActions.categoryVideoLoadError(err, store));
        log.error(
          err,
          `Error in category video actions, message: ${err.message}`
        );
      });
  };
}
